import React from "react";
import ProposedVariationRouter from './prop/Router';
export { getFields, getReplyFields } from './prop/Router';
export { getQuoteFields, getQuoteReplyFields } from './quotes/Router';

export default function SupplierProposedVariationRouter(props) {
    return <ProposedVariationRouter {...props}/>;
}